import Swal from "sweetalert2";
import Cookies from "js-cookie";

const savedLanguage = Cookies.get("language");

class FormErrorPopup {
  constructor() {
    this.errors = [];
  }

  addError(errorText) {
    this.errors.push(errorText);
  }

  clearErrors() {
    this.errors = [];
  }

  showErrors() {
    if (this.errors.length === 1) {
      Swal.fire({
        icon: "error",
        title:
          savedLanguage === "en"
            ? "Invalid Input:"
            : savedLanguage === "cn"
              ? "以下栏目资料无效:"
              : "以下欄目資料無效:",
        text: "• " + this.errors[0],
      });
    } else if (this.errors.length > 1) {
      const errorText = this.errors.map((error) => `• ${error}`).join("<br>");
      Swal.fire({
        icon: "error",
        title:
          savedLanguage === "en"
            ? "Invalid Input:"
            : savedLanguage === "cn"
              ? "以下栏目资料无效:"
              : "以下欄目資料無效:",
        html: errorText,
      });
    }
  }
}

const formErrorPopupInstance = new FormErrorPopup();

export default formErrorPopupInstance;
